import React from 'react';
import { ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { useAgreementTemplateQuery } from '@uplift/queries';
import { CollaborativeAgreementUnsigned } from '@uplift/api';
import { Draw } from '@mui/icons-material';
import { makeStyles } from 'tss-react/mui';


const useCollaborativeAgreementUnsignedListItemStyles = makeStyles()(theme => ({
  root: {
    background: `linear-gradient(to right, ${theme.palette.error.background}, #fff, #fff)`,

    '&.Mui-selected': {
      borderRight: '3px solid',
      borderRightColor: theme.palette.secondary.main,
      background: `linear-gradient(to right, ${theme.palette.error.background}, ${theme.palette.grey[100]}, ${theme.palette.grey[100]})`,
    }
  },
}));

export const CollaborativeAgreementUnsignedListItem: React.VFC<{
  document: CollaborativeAgreementUnsigned;
  onClick: () => void;
  selected: boolean;
}> = ({
  document,
  onClick,
  selected,
}) => {
  const { classes } = useCollaborativeAgreementUnsignedListItemStyles();
  const { data: template } = useAgreementTemplateQuery(document.agreementTemplateId);

  return (
    <ListItemButton
      onClick={onClick}
      selected={selected}
      className={classes.root}
      sx={{
        '&.Mui-selected': {
          borderRight: '3px solid',
          borderRightColor: 'secondary.main'
        }
      }}
    >
      <ListItemIcon><Draw color="error" /></ListItemIcon>
      <ListItemText
        primary={template.name}
        secondary="Pending signature"
      />
    </ListItemButton>
  );
};
